import React, { Component } from 'react';
import Fade from 'react-reveal';
import { connect } from 'react-redux';
import lang from '../../lang/lang.json';
import './howToGetHolidays.scss';

class HowToGetHolidays extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onSelectCityHandler: '',
      isMobile: false,
    };
  }
  componentDidMount() {
    if (window.innerWidth <= 768) {
      this.setState({
        isMobile: true,
      });
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      onSelectCityHandler: props.cityHandler,
    });
  }

  render() {
    return (
      <div id="howToGetHolidays ">
        <div
          className={
            this.state.isMobile
              ? 'howToGetHolidays container mobi-center'
              : 'howToGetHolidays'
          }
        >
          <Fade bottom>
            <div className="how-to-get-form ">
              <div
                className={
                  this.state.isMobile
                    ? 'mobile-center-container '
                    : 'container p-0 p-lg-3 d-flex justify-content-center '
                }
              >
                <div className="row holidays-div holiday-container col-lg-10">
                  <div className="col-lg-12 col-md-12 col-sm-12 holidays-title">
                    <div className="how-to-get-header">
                      {lang.HOW_GET_HOLIDAY_TITLE[this.props.language]}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 mb-md-3 mb-sm-5 col-sm-12 holidays-text-div ">
                    <div className="holiday-number">1</div>
                    <div className="svg-layer">
                      <div className="text-padding">
                        <div className="sub-title mt-lg-3 holidays-text text-whitespace">
                          {lang.HOW_GET_HOLIDAY_STEP_1[this.props.language]}
                          <br />
                          {lang.HOW_GET_HOLIDAY_STEP_1_1[this.props.language]}
                          <br />
                          {lang.HOW_GET_HOLIDAY_STEP_1_2[this.props.language]}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 mb-md-3 mb-sm-5 col-sm-12  holidays-text-div">
                    <div className="holiday-number">2</div>
                    <div className="svg-layer">
                      <div className="text-padding">
                        <div className="sub-title mt-lg-3 mobile-padding holidays-text text-whitespace ">
                          {lang.HOW_GET_HOLIDAY_STEP_2[this.props.language]}{' '}
                          <br />
                          {lang.HOW_GET_HOLIDAY_STEP_2_1[this.props.language]}
                          <br />
                          {lang.HOW_GET_HOLIDAY_STEP_2_2[this.props.language]}
                          <br />
                          {lang.HOW_GET_HOLIDAY_STEP_2_3[this.props.language]}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language.language,
  };
}

export default connect(mapStateToProps)(HowToGetHolidays);
